// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".s-module__wrap--Z6b7Q {\n  padding: 16px 0;\n  min-height: 141px;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/dashboard/PPAKlarityReviewsDashboradPage/components/UploadReviewsOverviewModal/s.module.less"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,iBAAA;AACJ","sourcesContent":[".wrap {\n    padding: 16px 0;\n    min-height: 141px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": "s-module__wrap--Z6b7Q"
};
export default ___CSS_LOADER_EXPORT___;
